import { createStore, createLogger } from 'vuex';
import actions from './actions';
import modules from './modules';

const debug =
  process.env.NODE_ENV !== 'production' &&
  process.env.NODE_ENV !== 'development' &&
  process.env.NODE_ENV !== 'testing';

const store = createStore({
  actions,
  modules,
  strict: debug,
  plugins: debug ? [createLogger()] : []
});

export default store;
